import el from '@finn-no/create-element';

export default {
    dependencies: [
        '$element',
        'searchmanager',
        '$controllerator',
        'trackingservice',
        'savedsearchesservice',
        'loginservice',
    ],
    // eslint-disable-next-line max-params
    callable(
        element,
        searchmanager,
        controllerator,
        trackingservice,
        savedsearchesservice,
        loginservice
    ) {
        const saveSearchTeaserEle = element.querySelector(
            '[data-save-search-teaser]'
        );
        const feedbackAfterSpidLoginEle = element.querySelector(
            '[data-save-search-teaser-feedback-after-login]'
        );

        if (!saveSearchTeaserEle || !feedbackAfterSpidLoginEle) {
            return;
        }

        const url = new URL(document.baseURI);

        // A login parameter will be added to the SPiD login redirect. This will suggest that the user logged in and the search can be saved
        // immediately after login and SPiD redirected back to saved search.
        const parameterFromSpidLoginRedirect = 'saveSearchTeaserAutoSave';

        if (url.searchParams.has(parameterFromSpidLoginRedirect)) {
            const isRedirectedFromSpidLogin = true;

            url.searchParams.delete(parameterFromSpidLoginRedirect);
            window.history.replaceState(null, null, url);
            saveSearch(isRedirectedFromSpidLogin);
        } else {
            const saveButton = el(
                'button.mts.blank.pan',
                {
                    'data-save-search-teaser-save': '',
                    onclick: handleSaveButtonClick,
                },
                'Ja, takk'
            );

            // This will potentially send a lot of events to Adobe and is temporally not used
            // sendTrackingEventWith("show-teaser", "start");
            saveSearchTeaserEle.appendChild(createSaveSearchEle(saveButton));
        }

        function handleSaveButtonClick(event) {
            sendTrackingEventWith('click', '');
            const button = event.target;
            button.setAttribute('disabled', true);
            button.classList.add('inprogress');
            saveSearch();
        }

        function sendTrackingEventWith(eventDetail, eventFlag) {
            trackingservice.trackEventObject({
                analyticsName: `search.save-search.${eventDetail}`,
                eventFlags: eventFlag,
                stringValue: 'searchhitslimit',
            });
        }

        function createSaveSearchEle(buttonEle) {
            return el(
                'p.pal',
                null,
                el(
                    'div',
                    null,
                    'Vil du bli varslet når det kommer nye treff i dette søket?'
                ),
                buttonEle
            );
        }

        function saveSearch(isRedirectedFromSpidLogin) {
            if (loginservice.isLoggedIn()) {
                const title = document.title.replace(/.*– /, ''); // Everything before and including "FINN – "
                const notify = true;
                const params = searchmanager.getSearchParams();
                savedsearchesservice
                    .createSavedSearch(
                        params.vertical,
                        params.segment,
                        params.args,
                        title,
                        notify
                    )
                    .then(
                        response => {
                            onSaveSuccess(response, isRedirectedFromSpidLogin);
                        },
                        response => {
                            onSaveFail(response, isRedirectedFromSpidLogin);
                        }
                    );
            } else {
                sendTrackingEventWith('need-login', '');
                renderLogin();
            }
        }

        function renderLogin() {
            saveSearchTeaserEle.innerHTML = '';

            const currentPageWithLoginParam = new URL(document.baseURI);
            currentPageWithLoginParam.searchParams.set(
                parameterFromSpidLoginRedirect,
                ''
            );

            const url = new URL('/loginForm.html', document.baseURI);
            url.searchParams.set('redirectTo', currentPageWithLoginParam);

            saveSearchTeaserEle.appendChild(createLoginEle(url.toString()));
            controllerator.run();
        }

        function createLoginEle(loginUrl) {
            return el(
                'p.pal',
                { 'data-save-search-teaser-login': '' },
                el(
                    'div.mbs.centerify',
                    null,
                    'Logg inn slik at vi vet hvem vi skal varsle'
                ),
                el(
                    'a',
                    {
                        'data-controller': 'loginLinkValidation',
                        href: loginUrl,
                    },
                    'Logg inn'
                ),
                el(
                    'a.mll',
                    {
                        'data-controller': 'loginLinkValidation',
                        href: loginUrl,
                    },
                    'Ny bruker'
                )
            );
        }

        function onSaveSuccess(response, isRedirectedFromSpidLogin) {
            sendTrackingEventWith('done', 'success');

            const title = response && response.title ? response.title : '';
            const searchSavedReceiptEle = createSearchSavedReceiptEle(title);

            searchSavedReceiptEle.style.opacity = '0';
            searchSavedReceiptEle.style.transition = 'opacity 0.6s';

            if (isRedirectedFromSpidLogin) {
                feedbackAfterSpidLoginEle.innerHTML = '';
                feedbackAfterSpidLoginEle.appendChild(
                    el(
                        'div.pal.centerify',
                        { style: 'width: 100%;' },
                        el('p', null, searchSavedReceiptEle)
                    )
                );
            } else {
                saveSearchTeaserEle.innerHTML = '';
                saveSearchTeaserEle.appendChild(searchSavedReceiptEle);
            }

            window.requestAnimationFrame(() => {
                searchSavedReceiptEle.style.opacity = '1';
            });
        }

        function createSearchSavedReceiptEle(title) {
            return el(
                'p.pal',
                { 'data-save-search-teaser-receipt': '' },
                el(
                    'div.t3',
                    null,
                    'Du får nå varsel om nye treff på e-post og i appen på mobil'
                ),
                el(
                    'div',
                    null,
                    `Søket «${title}» finner du igjen på «Min FINN» under `,
                    el('a', { href: '/user/savedsearches.html' }, 'Lagrede søk')
                )
            );
        }

        function onSaveFail(response, isRedirectedFromSpidLogin) {
            sendTrackingEventWith('try-again', '');

            const tryAgainEle = createTryAgainEle();
            tryAgainEle.style.opacity = '0';
            tryAgainEle.style.transition = 'opacity 0.6s';

            if (isRedirectedFromSpidLogin) {
                feedbackAfterSpidLoginEle.innerHTML = '';
                feedbackAfterSpidLoginEle.appendChild(tryAgainEle);
            } else {
                saveSearchTeaserEle.innerHTML = '';
                saveSearchTeaserEle.appendChild(tryAgainEle);
            }

            window.requestAnimationFrame(() => {
                tryAgainEle.style.opacity = '1';
            });
        }

        function createTryAgainEle() {
            const buttonEle = el(
                'button.mts.blank.pan',
                {
                    'data-save-search-teaser-try-again': '',
                    onclick: handleTryAgainClick,
                },
                'Prøv på nytt'
            );
            return el(
                'p.pal',
                null,
                el(
                    'div.t3',
                    null,
                    'Beklager, noe galt skjedde under lagring av søket '
                ),
                buttonEle
            );
        }

        function handleTryAgainClick(event) {
            const button = event.target;
            button.setAttribute('disabled', true);
            button.classList.add('inprogress');

            const feedbackAfterLoginEle = event.target.closest(
                '[data-save-search-teaser-feedback-after-login]'
            );

            // You're already logged in if you're getting the option to retry, and is there not redirected from SPiD login.
            const hasJustLoggedIn = !!feedbackAfterLoginEle;

            saveSearch(hasJustLoggedIn);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/saveSearchTeaser.js